import React from "react";
import "./App.css";

import Landing from "./pages/Landing";

function App() {
  return (
    <div className="bg-[#ffffff]">
      <Landing/>
    </div>
  );
}

export default App;
